import React from "react";
import { v4 as uuidv4 } from "uuid";
import { SubSection } from "./SubSection";
export var Fieldset = function (_a) {
    var children = _a.children, legend = _a.legend, id = _a.id, _b = _a.captionType, captionType = _b === void 0 ? "legend" : _b;
    var className = captionType === "label" ? "form-group" : "";
    var uniqueId = id || uuidv4();
    return (React.createElement("fieldset", { id: uniqueId, className: className },
        captionType === "label" ? (React.createElement("span", { className: "form-control-static-label" },
            " ",
            legend,
            " ")) : (React.createElement(SubSection, { title: legend, id: "".concat(uniqueId, "-subSection") })),
        children));
};
